import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getOrderDetails } from "../../api/orders";

export default function OrderView() {
  const location = useLocation();
  const id = location?.state?.orderId;

  const [order, setOrder] = useState(null);
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getOrderDetails(id);

        setOrder(res?.data || res);
      } catch (err) {
        console.error(err);
      }
    };

    if (id) {
      load();
    }
  }, [id]);

  if (!order) return <h5>Loading...</h5>;

  return (
    <div className="container-fluid p-4">
      <h5 className="mb-4">View Order</h5>

      <div className="row g-4 mb-3">
        {/* Customer Information */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Customer Information
            </div>
            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Customer Name : </span>
                <span>{order.address?.fullName || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Mobile : </span>
                <span>{order.address?.phone || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">City : </span>
                <span>{order.address?.city || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Pincode : </span>
                <span>{order.address?.pincode || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>
        {/* Order Information */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Order Information
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Order ID : </span>
                <span>{order.orderId || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Order Date : </span>
                <span>{formatDate(order.createdAt)}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Status : </span>
                <span>{order.status}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Payment : </span>
                <span>{order.payment?.paymentStatus || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-4">
        {/* Product Details */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Product Details
            </div>

            <div className="card-body p-2">
              {order.items?.map((item, index) => (
                <div
                  key={index}
                  className={
                    index !== order.items.length - 1
                      ? "border-bottom pb-2 mb-1"
                      : ""
                  }
                >
                  <div className="mb-1">
                    <span className="text-muted ">Product : </span>
                    <span>{item.name}</span>
                  </div>

                  <div className="mb-1">
                    <span className="text-muted ">Variation : </span>
                    <span>{item.selections?.variantName || "N/A"}</span>
                  </div>

                  <div className="mb-1">
                    <span className="text-muted ">Quantity : </span>
                    <span>{item.quantity}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Payment Summary */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Payment Summary
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Subtotal : </span>
                <span>₹{order.subtotal || 0}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Tax : </span>
                <span>₹{order.tax?.totalTax || 0}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Shipping : </span>
                <span>₹{order.shipment?.shippingCharge || 0}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">
                  Payment Method :{" "}
                </span>
                <span>{order.payment?.method || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">
                  Payment Status :{" "}
                </span>
                <span>{order.payment?.paymentStatus || "N/A"}</span>
              </div>

              <hr />

              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-bold">Total Amount :</span>
                <h5 className="mb-0 text-success">₹{order.total || 0}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-4">
        {/* Shipping Details */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Shipping Details
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Dispatch Date : </span>
                <span>{formatDate(order.shipment?.dispatch_date)}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Courier : </span>
                <span>{order.shipment?.courierName || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">
                  Shipment Status :{" "}
                </span>
                <span>{order.shipment?.shipmentStatus || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">Delivery Days : </span>
                <span>{order.shipment?.deliveryDays || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Delivery Address */}
        <div className="col-lg-6">
          <div className="card shadow-sm h-100">
            <div className="card-header bg-gray text-dark p-2">
              Delivery Address
            </div>

            <div className="card-body p-2">
              <div className="mb-1">
                <span className="text-muted ">Address : </span>
                <span>
                  {order.address?.address || order.address?.addressLine1 || ""}
                  {order.address?.addressLine2
                    ? `, ${order.address.addressLine2}`
                    : ""}
                </span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">City : </span>
                <span>{order.address?.city || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted ">State : </span>
                <span>{order.address?.state || "N/A"}</span>
              </div>

              <div className="mb-1">
                <span className="text-muted">Pincode : </span>
                <span>{order.address?.pincode || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
